import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Home, Compass, ShoppingCart, User } from "lucide-react";
import { useCart } from "@/context/CartContext";

const ITEMS = [
  { to: "/", label: "الرئيسية", icon: Home, key: "home" },
  { to: "/browse", label: "تصفّح", icon: Compass, key: "browse" },
  { to: "/cart", label: "السلة", icon: ShoppingCart, key: "cart" },
  { to: "/account", label: "حسابي", icon: User, key: "account" },
];

export default function TopNav() {
  const nav = useNavigate();
  const loc = useLocation();
  const { count } = useCart();

  return (
    <div
      data-testid="top-nav"
      className="shrink-0 z-40 px-3 md:px-6 py-2.5"
      style={{ background: "var(--k-ink)", borderBottom: "1px solid rgba(255,255,255,.08)" }}
    >
      <div className="flex items-center gap-2 md:gap-5 mx-auto" style={{ maxWidth: 1180 }}>
        <button
          data-testid="brand-home"
          onClick={() => nav("/")}
          className="k-tap hidden md:flex flex-col text-right leading-tight border-0 bg-transparent shrink-0"
        >
          <span className="font-head font-black text-[20px] text-white tracking-tight">كزيوني</span>
          <span className="text-[10px]" style={{ color: "#C7B08A" }}>سوق الجملة من تاجر لتاجر</span>
        </button>
        <div className="flex gap-1 flex-1 md:flex-none md:mr-auto">
          {ITEMS.map((it) => {
            const active = loc.pathname === it.to;
            const Icon = it.icon;
            return (
              <button
                key={it.key}
                data-testid={`topnav-${it.key}`}
                onClick={() => nav(it.to)}
                className="k-tap flex-1 md:flex-none md:px-5 flex items-center justify-center gap-1.5 py-2 rounded-xl relative border-0 transition-all"
                style={{
                  background: active ? "var(--k-gold)" : "transparent",
                  color: active ? "var(--k-ink)" : "#C7B08A",
                  fontWeight: active ? 800 : 600,
                }}
              >
                <Icon size={17} strokeWidth={active ? 2.6 : 2} />
                <span className="text-[12px]">{it.label}</span>
                {it.key === "cart" && count > 0 && (
                  <span
                    data-testid="topnav-cart-badge"
                    className="font-num absolute text-white text-[9.5px] font-bold flex items-center justify-center"
                    style={{ top: 2, insetInlineStart: 6, minWidth: 16, height: 16, borderRadius: 8, background: "var(--k-ruby)", padding: "0 4px" }}
                  >
                    {count}
                  </span>
                )}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
